"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refEqual = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */
var refEqual = function (left, right) {
    return (0, firestore_1.refEqual)(
    // @ts-expect-error
    left, right);
};
exports.refEqual = refEqual;
